
/* injects from baggage-loader */

'use strict';

import ProjectController from './project.controller';
import ProjectTemplate from './project.html';

export default class ProjectComponent {
		constructor() {
				this.templateUrl = ProjectTemplate;
				this.controller = ProjectController;
				this.controllerAs = '$ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					project: '<',
					comments: '<',
					documents: '<',
					rewards: '<',
					sections: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/project/project.component.js